import Source from '../Source';
import MapProperties from '../../map/Properties';

import store from '../../../store/configureStore';

export default class GovernanceSource extends Source {
  currentView = new MapProperties();
  isLoading = false;
  loadComplete = false;
  url = '';
  coverage = [];
  features = new Map();
  constructor(initializer = {}) {
    super(initializer);
    Object.assign(this, initializer);
  }
  initialize() {
    if (store) {
      store.subscribe(GovernanceSource.onMoveMap);
    }
  }
  setLoadingFlag() {
    this.isLoading = true;
    this.loadComplete = false;
  }
  unsetLoadingFlag() {
    this.isLoading = false;
    this.loadComplete = true;
  }
  getSchoolDataInView() {
    let map = (store.getState()).map;
    if (map.view.zoom < 14)
      return new Map();
    let north_latitude = map.view.bounds._northEast.lat;
    let south_latitude = map.view.bounds._southWest.lat;
    let west_longitude = map.view.bounds._southWest.lng;
    let east_longitude = map.view.bounds._northEast.lng;
    if (this.features) {
      let features = (Array.from(this.features)).map(([key, feature]) => {
        if ((feature.geometry.coordinates[1] < north_latitude)
          && (feature.geometry.coordinates[1] > south_latitude)
          && (feature.geometry.coordinates[0] < east_longitude)
          && (feature.geometry.coordinates[0] > west_longitude)) {
          return [key, feature];
        }
      }).filter((feature) => feature !== undefined);
      return new Map(features);
    }
    return new Map();
  }
  static onMoveMap() {
    //Checking selected category
    if (!((store.getState()).viewSettings["governance"]))
      return;
    let currentView = (store.getState()).map;
    let gov = (store.getState()).gov;
    if ((gov.currentView.view !== currentView.view) && (!gov.isLoading)
      && (currentView.view.zoom > 14)) {
      let area_already_covered = false;
      for (var i = 0; i < gov.coverage.length; i++) {
        let center = (gov.coverage[i]).center;
        let radius = (gov.coverage[i]).radius;
        let lat1 = center.lat,
          lng1 = center.lng,
          lat2 = currentView.view.center.lat,
          lng2 = currentView.view.center.lng;
        let φ1 = (parseFloat(lat1) / 180) * Math.PI,
          φ2 = (parseFloat(lat2) / 180) * Math.PI,
          Δλ = (parseFloat(lng2 - lng1) / 180) * Math.PI,
          R = 6371e3;
        let d = Math.acos(
          Math.sin(φ1) * Math.sin(φ2) +
          Math.cos(φ1) * Math.cos(φ2) * Math.cos(Δλ)) * R;
        if (d <= (radius * 0.8)) {
          area_already_covered = true;
          break;
        }
      }
      if (!area_already_covered) {
        store.dispatch({
          type: GovernanceSource.ACTIONS.BEGIN_GOV_DATA_LOAD
        });
        if ((currentView) && (currentView.view)
          && (currentView.view.center) && (currentView.view.center.lat)
          && (currentView.view.center.lng) && (currentView.view.radius)
          && (currentView.view.zoom)) {
          let north_latitude = currentView.view.bounds._northEast.lat;
          let south_latitude = currentView.view.bounds._southWest.lat;
          let west_longitude = currentView.view.bounds._southWest.lng;
          let east_longitude = currentView.view.bounds._northEast.lng;
          //Fetch MLA records for Governance category
          gov.url = 'https://rbndapi.cloudhop.in/es/govmla/_search?size=10000';
          fetch(gov.url)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              let govMlaHits = data.hits.hits;
              let govMlaSource = [];
              let countMla = 0;
              govMlaHits.forEach(element => {
                govMlaSource.push(element._source);
                countMla++;
              });
              let govFeaturesData = [];
              govMlaSource.forEach(element => {
                govFeaturesData.push({
                  "type": "Feature",
                  "geometry": {
                    "coordinates": [element.Long, element.Lat],
                    "type": "Point"
                  },
                  "properties": {
                    "mla": element.MLA,
                    "constituency": element.Constituency,
                    "party": element.Party,
                    "id": element.id,
                    "corporator_name": null,
                    "contact_no": null,
                    "ward_no": null,
                    "ward_name": null,
                    "address": null,
                    "pincode": null,
                    "age": null,
                    "subCategory": null,
                    "category": null,
                    "description": null,
                    "civicAgency": null,
                    "statusTitle": null,
                    "type": {
                      "id": element.type,
                      "name": element.type
                    }
                  }
                })
              })
              //Fetch Corporator records for Governance category
              gov.url = 'https://rbndapi.cloudhop.in/es/govcrp/_search?size=10000';
              fetch(gov.url)
                .then((response) => {
                  return response.json();
                })
                .then((data) => {
                  let govCrpHits = data.hits.hits;
                  let govCrpSource = [];
                  let countCrp = 0;
                  govCrpHits.forEach(element => {
                    govCrpSource.push(element._source);
                    countCrp++;
                  });
                  govCrpSource.forEach(element => {
                    govFeaturesData.push({
                      "type": "Feature",
                      "geometry": {
                        "coordinates": [element.Long, element.Lat],
                        "type": "Point"
                      },
                      "properties": {
                        "mla": null,
                        "constituency": null,
                        "party": element.party,
                        "id": element.id + countMla,
                        'pincode': element.pincode,
                        'gender': element.gender,
                        'corporator_name': element.corporator_name,
                        'contact_no': element.contact_no,
                        'age': element.age,
                        'address': element.address,
                        "ward_name": element.ward_name,
                        "ward_no": element.ward_no,
                        "subCategory": null,
                        "category": null,
                        "description": null,
                        "civicAgency": null,
                        "statusTitle": null,
                        "type": {
                          "id": element.type,
                          "name": element.type
                        }
                      }
                    })
                  })
                  let govFinalDataFormat = {
                    "features": govFeaturesData,
                    "count": countMla + countCrp,
                    "type": "FeatureCollection"
                  }
                  let uids = [];
                  if ((govFinalDataFormat.count) && (govFinalDataFormat.count > 0)) {
                    for (var i = 0; i < govFinalDataFormat.count; i++) {
                      uids.push(govFinalDataFormat.features[i].properties.id);
                    }
                  }
                  store.dispatch({
                    type: GovernanceSource.ACTIONS.GOV_DATA_LOAD_COMPLETE,
                    view: currentView,
                    data: govFinalDataFormat,
                    uids
                  });
                  store.dispatch({
                    type: MapProperties.ACTIONS.ADD_FEATURES,
                    data: govFinalDataFormat,
                    uids
                  });
                })
            })
          // })
        }
      }
    }
  }
  static get ACTIONS() {
    return {
      BEGIN_GOV_DATA_LOAD: 'BEGIN_GOV_DATA_LOAD',
      GOV_DATA_LOAD_COMPLETE: 'GOV_DATA_LOAD_COMPLETE'
    };
  }
  static reducer(state = {}, action) {
    switch (action.type) {
      case GovernanceSource.ACTIONS.BEGIN_GOV_DATA_LOAD: {
        let gov = new GovernanceSource(state);
        gov.setLoadingFlag();
        return gov;
      }
      case GovernanceSource.ACTIONS.GOV_DATA_LOAD_COMPLETE: {
        let gov = new GovernanceSource(state);
        gov.unsetLoadingFlag();
        gov.currentView = action.view;
        gov.coverage = ([].concat(gov.coverage)).concat([
          {
            center: Object.assign({}, action.view.view.center),
            radius: action.view.view.radius,
          }
        ]);
        if ((action.data.count) && (action.data.count > 0)) {
          action.data.features.map((feature, index) => {
            if (gov.features.has(action.uids[index])) {
            } else {
              gov.features.set(action.uids[index], feature);
            }
          });
        }
        return gov;
      }
      default: {
        return state;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/source/governance/index.js